import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import img from "../assests/images/South-Travels-Footer-Logo.png";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#002B45] text-white">

      {/* =========================================================
          BACKGROUND DECORATION
      ========================================================== */}

      <div className="pointer-events-none absolute -right-40 -top-40 h-[420px] w-[420px] rounded-full bg-[#174EA6]/20 blur-3xl" />

      <div className="pointer-events-none absolute -bottom-40 -left-40 h-[420px] w-[420px] rounded-full bg-[#FFC928]/10 blur-3xl" />

      <div className="pointer-events-none absolute right-[30%] top-[20%] h-32 w-32 rounded-full border border-white/[0.03]" />

      {/* =========================================================
          MAIN FOOTER
      ========================================================== */}

      <div className="relative mx-auto max-w-7xl px-4 pb-8 pt-12 sm:px-6 sm:pt-14 lg:px-8 lg:pt-16">

        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12 lg:gap-10">

          {/* =====================================================
              BRAND
          ====================================================== */}

          <div className="lg:col-span-4">

            <Link
              to="/"
              className="group inline-flex items-center"
            >
              <img
                src={img}
                alt="Dubai Hotel Rates"
                className="h-14 w-auto max-w-[230px] object-contain transition duration-300 group-hover:scale-105 sm:h-16"
              />
            </Link>

            <p className="mt-5 max-w-sm text-sm leading-6 text-white/65">
              Discover the best hotels, great deals and unforgettable
              stays across Dubai. We make finding your perfect hotel
              simple, convenient and stress-free.
            </p>

            {/* Trust badge */}
            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-2">
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#FFC928] text-[10px] font-bold text-[#002B45]">
                ✓
              </span>

              <span className="text-[10px] font-semibold text-white/75">
                Trusted Hotel Booking
              </span>
            </div>

            {/* Social */}
            <div className="mt-6 flex items-center gap-2.5">

              <a
                href="https://www.facebook.com/SouthTravelsOfficialPage/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/[0.05] text-white/70 transition-all duration-300 hover:-translate-y-1 hover:border-[#FFC928] hover:bg-[#FFC928] hover:text-[#002B45]"
              >
                <FaFacebookF className="text-xs" />
              </a>

              <a
                href="https://www.instagram.com/southtravels8376/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/[0.05] text-white/70 transition-all duration-300 hover:-translate-y-1 hover:border-[#FFC928] hover:bg-[#FFC928] hover:text-[#002B45]"
              >
                <FaInstagram className="text-xs" />
              </a>

              <a
                href="https://x.com/SouthTravels"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
                className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/[0.05] text-white/70 transition-all duration-300 hover:-translate-y-1 hover:border-[#FFC928] hover:bg-[#FFC928] hover:text-[#002B45]"
              >
                <FaTwitter className="text-xs" />
              </a>

              <a
                href="https://www.linkedin.com/company/southtravelsuae/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 bg-white/[0.05] text-white/70 transition-all duration-300 hover:-translate-y-1 hover:border-[#FFC928] hover:bg-[#FFC928] hover:text-[#002B45]"
              >
                <FaLinkedinIn className="text-xs" />
              </a>

            </div>
          </div>

          {/* =====================================================
              EXPLORE
          ====================================================== */}

          <div className="lg:col-span-2">

            <div className="mb-5 flex items-center gap-2">
              <span className="h-[2px] w-5 rounded-full bg-[#FFC928]" />

              <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-white">
                Explore
              </h4>
            </div>

            <ul className="space-y-3">

              <li>
                <Link
                  to="/"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/hotels"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  Hotels
                </Link>
              </li>

              <li>
                <Link
                  to="/destinations"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  Destinations
                </Link>
              </li>

              <li>
                <Link
                  to="/blogs"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  Travel Guides
                </Link>
              </li>

            </ul>
          </div>

          {/* =====================================================
              COMPANY
          ====================================================== */}

          <div className="lg:col-span-2">

            <div className="mb-5 flex items-center gap-2">
              <span className="h-[2px] w-5 rounded-full bg-[#FFC928]" />

              <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-white">
                Company
              </h4>
            </div>

            <ul className="space-y-3">

              <li>
                <Link
                  to="/about-us"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  About Us
                </Link>
              </li>

              <li>
                <Link
                  to="/contact-us"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  Contact Us
                </Link>
              </li>

              <li>
                <Link
                  to="/privacy-policy"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  Privacy Policy
                </Link>
              </li>

              <li>
                <Link
                  to="/terms-conditions"
                  className="group flex items-center gap-2 text-sm text-white/60 transition-all duration-300 hover:translate-x-1 hover:text-white"
                >
                  <FaArrowRight className="text-[8px] text-[#FFC928] opacity-0 transition-opacity group-hover:opacity-100" />
                  Terms & Conditions
                </Link>
              </li>

            </ul>
          </div>

          {/* =====================================================
              CONTACT
          ====================================================== */}

          <div className="lg:col-span-4">

            <div className="mb-5 flex items-center gap-2">
              <span className="h-[2px] w-5 rounded-full bg-[#FFC928]" />

              <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-white">
                Get In Touch
              </h4>
            </div>

            <div className="space-y-4">

              {/* Location */}
              <div className="group flex items-start gap-3">

                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/[0.05] transition-all duration-300 group-hover:border-[#FFC928]/40 group-hover:bg-[#FFC928]">
                  <FaMapMarkerAlt className="text-xs text-[#FFC928] group-hover:text-[#002B45]" />
                </div>

                <div>
                  <p className="text-[10px] font-semibold uppercase tracking-wider text-white/35">
                    Location
                  </p>

                  <p className="mt-1 max-w-xs text-sm leading-5 text-white/65">
                    Office 302, 3rd Flr. HDS Tower Cluster F,
                    Jumeirah Lakes Towers, Dubai
                  </p>
                </div>

              </div>

              {/* Phone */}
              <div className="group flex items-start gap-3">

                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/[0.05] transition-all duration-300 group-hover:border-[#FFC928]/40 group-hover:bg-[#FFC928]">
                  <FaPhoneAlt className="text-xs text-[#FFC928] group-hover:text-[#002B45]" />
                </div>

                <div>
                  <p className="text-[10px] font-semibold uppercase tracking-wider text-white/35">
                    Phone
                  </p>

                  <a
                    href="tel:+971 4 447 3839"
                    className="mt-1 block text-sm text-white/65 transition-colors hover:text-[#FFC928]"
                  >
                    +971 4 447 3839
                  </a>
                </div>

              </div>

              {/* Email */}
              <div className="group flex items-start gap-3">

                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/[0.05] transition-all duration-300 group-hover:border-[#FFC928]/40 group-hover:bg-[#FFC928]">
                  <FaEnvelope className="text-xs text-[#FFC928] group-hover:text-[#002B45]" />
                </div>

                <div>
                  <p className="text-[10px] font-semibold uppercase tracking-wider text-white/35">
                    Email
                  </p>

                  <a
                    href="mailto:info@southtravels.com"
                    className="mt-1 block text-sm text-white/65 transition-colors hover:text-[#FFC928]"
                  >
                    info@southtravels.com
                  </a>
                </div>

              </div>

            </div>
          </div>
        </div>

        {/* =========================================================
            DIVIDER
        ========================================================== */}

        <div className="mt-10 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

        {/* =========================================================
            BOTTOM FOOTER
        ========================================================== */}

        <div className="flex flex-col items-center justify-between gap-4 pt-6 text-center md:flex-row md:text-left">

          <p className="text-xs text-white/40 sm:text-sm">
            © {new Date().getFullYear()} Dubai Hotel Rates.
            All rights reserved.
          </p>

          <div className="flex items-center gap-5">

            <Link
              to="/privacy-policy"
              className="text-xs text-white/40 transition-colors hover:text-[#FFC928] sm:text-sm"
            >
              Privacy
            </Link>

            <Link
              to="/terms-conditions"
              className="text-xs text-white/40 transition-colors hover:text-[#FFC928] sm:text-sm"
            >
              Terms
            </Link>

            <Link
              to="/contact-us"
              className="text-xs text-white/40 transition-colors hover:text-[#FFC928] sm:text-sm"
            >
              Contact
            </Link>

          </div>
        </div>

      </div>

      {/* =========================================================
          GOLD BOTTOM ACCENT
      ========================================================== */}

      <div className="h-1 bg-gradient-to-r from-[#174EA6] via-[#FFC928] to-[#174EA6]" />

    </footer>
  );
}